import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { HttpClientModule, HTTP_INTERCEPTORS, HttpClientJsonpModule } from '@angular/common/http';
import { RouteReuseStrategy } from '@angular/router';
import { JwtInterceptor } from './_core/_interceptors/jwt.interceptor';
import { ErrorInterceptor } from './_core/_interceptors/error.interceptor';
import { SameComponentRouteReuseStrategy } from './_core/_strategies/same-component-route-reuse-strategy';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { PrimeModule } from './prime.module';
import { FormsModule } from '@angular/forms';

import { MainModule } from './features/main-application/main.module';
import { CrmModule } from './features/crm/crm.module';
import { BusinessSalesModule } from './features/business-sales/business-sales.module';
import { PortalTenantInterceptor } from './_core/_interceptors/portal-tenant.interceptor';
import { GoogleMapsModule } from '@angular/google-maps';
import { NgxStripeModule } from 'ngx-stripe';
import { environment } from '../environments/environment';

@NgModule({
  declarations: [AppComponent],
  imports: [
    HttpClientJsonpModule,
    HttpClientModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    GoogleMapsModule,
    NgxStripeModule.forRoot(environment.stripe.publicKey),

    // custom modules
    MainModule,
    CrmModule,
    BusinessSalesModule,

    PrimeModule
  ],
  exports: [],
  providers: [
    MessageService,
    ConfirmationService,
    DialogService,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: PortalTenantInterceptor, multi: true },
    { provide: RouteReuseStrategy, useClass: SameComponentRouteReuseStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
